import BillingModel from "../../../types/billing-model";
import BillingFormData from "../types/billing-form.data";
import BillingsNode from "../../../common/types/billings-node";
import googleMapsRouteService from "../../../../../common/utils/google-maps-route/google-maps-route.service";
import BillingsOrderTaxiRailyRecalculate, {
  BillingsOrderTaxiRailyRecalculateBillingNode,
} from "../../../../../common/services/billings/order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate";

const createBillingNodes = (
  data: BillingsOrderTaxiRailyRecalculateBillingNode[],
): BillingsNode[] => {
  return data.map((billingNode, index) => {
    const previousItem = index - 1 >= 0 ? data[index - 1] : null;

    const url =
      previousItem !== null
        ? googleMapsRouteService.createGoogleMapsRouteUrl([
            { latitude: previousItem.lat, longitude: previousItem.lon },
            { latitude: billingNode.lat, longitude: billingNode.lon },
          ])
        : "";

    const result: BillingsNode = {
      id: billingNode.id,
      nodeId: billingNode.nodeId,
      lat: billingNode.lat,
      lon: billingNode.lon,
      description: billingNode.description,
      checkoutDate: billingNode.checkoutDate
        ? new Date(billingNode.checkoutDate)
        : null,
      checkoutEventUuid: billingNode.checkoutEventId,
      plannedDate: billingNode.plannedDate
        ? new Date(billingNode.plannedDate)
        : null,
      plannedDistance: billingNode.plannedDistance,
      orderId: billingNode.orderId,
      distance: billingNode.distance,
      haltingTime: billingNode.haltingTime,
      highwayCharge: billingNode.highwayCharge,
      isHighwayAllowed: billingNode.allowCharge,
      isEditable: billingNode.editableCoordinates,
      googleMapsUrl: url,
      position: index + 1,
    };

    return result;
  });
};

const createBillingData = (data: BillingsOrderTaxiRailyRecalculate) => {
  const billingDraft: BillingFormData = {
    billingNodes: createBillingNodes(data.billingNodes),
    contractDetails: {
      companyName: data.contract.cargoCompany.companyName,
      discountLimit: data.contract.discountLimit,
      haltingTimeRate: data.contract.haltingTimeRate,
      distanceRate: data.contract.distanceRate,
      isHighwayAllowedDuringRide: data.contract.allowChargeDuringRide,
      isHighwayAllowedWhenApproaching:
        data.contract.allowChargeWhileApproaching,
      isHighwayAllowedWhileReturning: data.contract.allowChargeWhileReturning,
      model: data.contract.model as BillingModel,
      haltingTimeAppliedAfter: data.contract.haltingTimeAfterMinutes,
    },
    discountAmount: data.discountAmount,
    haltingCost: data.haltingAmount,
    highwayCharge: data.highwayCharge,
    distance: data.distance,
    routeDistanceCost: data.distanceAmount,
    internalOrderId: data.cargoOrder.humanId,
    discount: data.discount,
    total: data.totalAmount,
    planEntryId: data.planEntryId,
    cargoOrderId: data.cargoOrder.id,
  };

  return billingDraft;
};

const billingDataFactory = {
  createBillingData,
};

export default billingDataFactory;
